import './button.css'

function Button({ buttonType, onClick, buttonValue }) {
    return (
        <button className="buttonComponent" onClick={onClick} type={buttonType}>{buttonValue}</button>
    );
}

export default Button;